import script from "./object_dayCollectionWeather.vue?vue&type=script&setup=true&lang=js"
export * from "./object_dayCollectionWeather.vue?vue&type=script&setup=true&lang=js"

import "./object_dayCollectionWeather.vue?vue&type=style&index=0&id=bab04822&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab04822"]])

export default __exports__